export const colorMap = new Uint8Array([
   59,  76, 192,
   60,  78, 193,
   61,  79, 194,
   62,  80, 194,
   63,  82, 195,
   64,  83, 196,
   65,  85, 196,
   66,  86, 197,
   67,  87, 197,
   68,  89, 198,
   69,  90, 199,
   70,  91, 199,
   71,  93, 200,
   72,  94, 200,
   73,  95, 201,
   74,  97, 202,
   75,  98, 202,
   76, 100, 203,
   77, 101, 203,
   78, 102, 204,
   79, 104, 204,
   81, 105, 205,
   82, 106, 206,
   83, 108, 206,
   84, 109, 207,
   85, 110, 207,
   86, 112, 208,
   87, 113, 208,
   89, 114, 209,
   90, 116, 209,
   91, 117, 210,
   92, 118, 210,
   93, 120, 211,
   95, 121, 211,
   96, 122, 212,
   97, 124, 212,
   98, 125, 213,
  100, 126, 213,
  101, 128, 214,
  102, 129, 214,
  103, 130, 214,
  105, 131, 215,
  106, 133, 215,
  107, 134, 216,
  109, 135, 216,
  110, 137, 217,
  111, 138, 217,
  113, 139, 218,
  114, 141, 218,
  115, 142, 218,
  117, 143, 219,
  118, 145, 219,
  119, 146, 220,
  121, 147, 220,
  122, 149, 220,
  123, 150, 221,
  125, 151, 221,
  126, 152, 222,
  128, 154, 222,
  129, 155, 222,
  130, 156, 223,
  132, 158, 223,
  133, 159, 223,
  135, 160, 224,
  136, 162, 224,
  138, 163, 225,
  139, 164, 225,
  140, 165, 225,
  142, 167, 226,
  143, 168, 226,
  145, 169, 226,
  146, 171, 227,
  148, 172, 227,
  149, 173, 227,
  151, 175, 228,
  152, 176, 228,
  154, 177, 228,
  155, 178, 229,
  157, 180, 229,
  159, 181, 229,
  160, 182, 230,
  162, 184, 230,
  163, 185, 230,
  165, 186, 230,
  166, 187, 231,
  168, 189, 231,
  170, 190, 231,
  171, 191, 232,
  173, 193, 232,
  174, 194, 232,
  176, 195, 232,
  178, 196, 233,
  179, 198, 233,
  181, 199, 233,
  183, 200, 234,
  184, 202, 234,
  186, 203, 234,
  188, 204, 234,
  189, 205, 235,
  191, 207, 235,
  193, 208, 235,
  194, 209, 236,
  196, 210, 236,
  198, 212, 236,
  200, 213, 236,
  201, 214, 237,
  203, 215, 237,
  205, 217, 237,
  207, 218, 237,
  208, 219, 238,
  210, 220, 238,
  212, 222, 238,
  214, 223, 238,
  215, 224, 239,
  217, 225, 239,
  219, 227, 239,
  221, 228, 239,
  223, 229, 240,
  225, 230, 240,
  226, 232, 240,
  228, 233, 240,
  230, 234, 241,
  232, 235, 241,
  234, 237, 241,
  236, 238, 241,
  238, 239, 242,
  239, 240, 242,
  241, 242, 242,
  242, 241, 241,
  242, 240, 239,
  241, 238, 237,
  241, 237, 235,
  241, 235, 232,
  241, 234, 230,
  240, 232, 228,
  240, 231, 226,
  240, 229, 224,
  239, 228, 222,
  239, 226, 219,
  239, 225, 217,
  238, 223, 215,
  238, 222, 213,
  238, 220, 211,
  237, 219, 209,
  237, 217, 207,
  237, 216, 205,
  236, 214, 203,
  236, 213, 201,
  236, 211, 199,
  235, 210, 196,
  235, 208, 194,
  235, 207, 192,
  234, 205, 190,
  234, 204, 188,
  233, 202, 186,
  233, 201, 184,
  233, 199, 182,
  232, 197, 180,
  232, 196, 179,
  232, 194, 177,
  231, 193, 175,
  231, 191, 173,
  230, 190, 171,
  230, 188, 169,
  230, 187, 167,
  229, 185, 165,
  229, 184, 163,
  228, 182, 161,
  228, 181, 159,
  228, 179, 158,
  227, 177, 156,
  227, 176, 154,
  226, 174, 152,
  226, 173, 150,
  226, 171, 148,
  225, 170, 147,
  225, 168, 145,
  224, 167, 143,
  224, 165, 141,
  223, 163, 140,
  223, 162, 138,
  223, 160, 136,
  222, 159, 134,
  222, 157, 133,
  221, 156, 131,
  221, 154, 129,
  220, 152, 128,
  220, 151, 126,
  219, 149, 124,
  219, 148, 123,
  218, 146, 121,
  218, 144, 119,
  217, 143, 118,
  217, 141, 116,
  217, 140, 114,
  216, 138, 113,
  216, 136, 111,
  215, 135, 110,
  215, 133, 108,
  214, 132, 107,
  214, 130, 105,
  213, 128, 104,
  212, 127, 102,
  212, 125, 101,
  211, 123,  99,
  211, 122,  98,
  210, 120,  96,
  210, 119,  95,
  209, 117,  93,
  209, 115,  92,
  208, 114,  90,
  208, 112,  89,
  207, 110,  88,
  207, 108,  86,
  206, 107,  85,
  205, 105,  83,
  205, 103,  82,
  204, 102,  81,
  204, 100,  79,
  203,  98,  78,
  203,  96,  77,
  202,  95,  75,
  201,  93,  74,
  201,  91,  73,
  200,  89,  72,
  200,  87,  70,
  199,  86,  69,
  198,  84,  68,
  198,  82,  67,
  197,  80,  65,
  197,  78,  64,
  196,  76,  63,
  195,  74,  62,
  195,  72,  61,
  194,  70,  60,
  193,  68,  58,
  193,  66,  57,
  192,  64,  56,
  192,  62,  55,
  191,  60,  54,
  190,  58,  53,
  190,  55,  52,
  189,  53,  51,
  188,  50,  50,
  188,  48,  49,
  187,  45,  48,
  186,  43,  47,
  186,  40,  46,
  185,  37,  45,
  184,  34,  44,
  184,  30,  43,
  183,  27,  42,
  182,  22,  41,
  181,  18,  40,
  181,  12,  39,
  180,   4,  38,
]);